module.exports = __webpack_public_path__ + "img/mike-48.49e2705a.jpg";